import { Tabs, TabsProps } from "antd";
import Heading from "components/Heading/Heading";
import Branches from "./components/Branches";
import Countries from "./components/Countries";
import Cities from "./components/Cities";
import Currencies from "./components/Currencies";
import Colors from "../Colors";
import Units from "../Units";
import Meagures from "../Meagures";
import Categories from "./components/Categories";
import Banks from "./components/Banks";
import Boxes from "./components/Boxs";
import Taxes from "./components/Taxes";
import CustomerTypes from "./components/CustomerTypes";

const onChange = (key: string) => {
  console.log(key);
};

const items: TabsProps["items"] = [
  {
    key: "0",
    label: "اكواد انواع العملاء",
    children: <CustomerTypes />,
  },
  {
    key: "99",
    label: "اكواد انواع المنتجات ",
    children: <Categories />,
  },
  {
    key: "1",
    label: "اكواد البلدان ",
    children: <Countries />,
  },
  {
    key: "2",
    label: "اكواد المدن",
    children: <Cities />,
  },
  {
    key: "4",
    label: "الفروع",
    children: <Branches />,
  },
  {
    key: "5",
    label: "العملات",
    children: <Currencies />,
  },
  {
    key: "51",
    label: "البنوك",
    children: <Banks />,
  },
  {
    key: "52",
    label: "الخزن",
    children: <Boxes />,
  },
  {
    key: "53",
    label: "الضرائب",
    children: <Taxes />,
  },
  {
    key: "6",
    label: "الالوان",
    children: <Colors />,
  },
  {
    key: "7",
    label: "الوحدات",
    children: <Units />,
  },
  {
    key: "8",
    label: "المقاسات",
    children: <Meagures />,
  },
];

function Settings() {
  return (
    <div>
      <Heading name={"اعدادات النظام"} />
      <div className="settings-tabs">
        <Tabs
          defaultActiveKey="0"
          onChange={onChange}
          type="card"
          items={items}
        />
      </div>
    </div>
  );
}

export default Settings;
